import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../common/user';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { Userdto } from '../common/userdto';
import { Jwtclient } from '../common/jwtclient';
import { SessionStorageService } from './session-storage.service';
import { CartService } from './cart.service';
import { Router } from '@angular/router';
  
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private apiUrl : string = `${environment.apiUrl}/security`;

  private loggedIn: BehaviorSubject<boolean>;
  isLoggedIn$: Observable<boolean>;

  constructor(
    private httpClient : HttpClient,
    private sessionStorage: SessionStorageService,
    private cartService: CartService,
    private router: Router
    ) {
      this.loggedIn = new BehaviorSubject<boolean>(this.hasToken());
      this.isLoggedIn$ = this.loggedIn.asObservable();
    }

  private hasToken(): boolean {
    return !!this.sessionStorage.getItem('token');
  }

  register(user : User):Observable<User>{
    return this.httpClient.post<User>(this.apiUrl+"/register", user);
  }

  login(userDto: Userdto):Observable<Jwtclient>{
    return this.httpClient.post<Jwtclient>(this.apiUrl+"/login", userDto).pipe(
      tap(response => {
        if (response && response.token) {
          this.loggedIn.next(true);
        }
      })
    );
  }

  googleLogin(idToken: string): Observable<Jwtclient> {
    return this.httpClient.post<Jwtclient>(this.apiUrl + '/google-login', { idToken }).pipe(
      tap(response => {
        if (response && response.token) {
          this.loggedIn.next(true);
        }
      })
    );
  }

  forgotPassword(email: string): Observable<{message: string}> {
    return this.httpClient.post<{message: string}>(this.apiUrl+"/forgot-password", { email });
  }

  resetPassword(token: string, newPassword: string): Observable<{message: string}> {
    return this.httpClient.post<{message: string}>(this.apiUrl+"/reset-password", { token, newPassword });
  }

  logout(): void {
    this.cartService.clearCart();
    this.sessionStorage.clear();
    this.loggedIn.next(false);
    this.router.navigate(['/']);
  }
}
